import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as s, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconThumbsUp",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], c = ["clip-path"], h = ["id"];
function f(e, t, r, _, g, i) {
  return n(), s("svg", {
    "aria-label": r.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--thumbs-up"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Thumbs Up",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M5.553.776A.5.5 0 0 1 6.006.5a2.065 2.065 0 0 1 1.98 2.559L7.636 4.5h2.279a1.5 1.5 0 0 1 1.44 1.92l-1.165 4a1.5 1.5 0 0 1-1.44 1.08H2A1.5 1.5 0 0 1 .5 10V6A1.5 1.5 0 0 1 2 4.5h1.38a.5.5 0 0 0 .447-.277V4.22L5.554.776ZM3 5.5H2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1v-5Zm1 5h4.75a.5.5 0 0 0 .48-.36l1.165-4a.5.5 0 0 0-.48-.64H7a.5.5 0 0 1-.486-.618l.5-2.06V2.82a1.065 1.065 0 0 0-.728-1.275L4.723 4.668A1.503 1.503 0 0 1 4 5.366V10.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, c),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, h)
    ])
  ], 10, p);
}
const S = /* @__PURE__ */ u(m, [["render", f]]);
export {
  S as default
};
//# sourceMappingURL=thumbs-up.js.map
